<label class="d-flex align-items-center">
  <app-body-sm [bold]="bold" [italic]="italic">
    <ng-content></ng-content>
    <span *ngIf="requiredField" class="asterisk">*</span>
  </app-body-sm>
  <app-popover *ngIf="popoverHelpText" [onHover]="true" [preferDisplayAbove]="true" matIcon="info_outline">
    {{ popoverHelpText }}
  </app-popover>
</label>
